import { render, staticRenderFns } from "./TextItem.vue?vue&type=template&id=6863c29a&"
import script from "./TextItem.vue?vue&type=script&lang=js&"
export * from "./TextItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports